var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary"},[_c('div',{staticClass:"summary__row"},[_c('div',{staticClass:"summary__amount"},[_vm._v(" "+_vm._s(_vm.summary)+" "),(_vm.loading)?_c('OLoader'):_vm._e()],1)]),_c('OErrors',{attrs:{"errors":_vm.errors.balance}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }